export default {
  SET_IS_PRINT (state, val) {
    state.isPrint = val
  },
}
